// import React from 'react';
// import PropTypes from 'prop-types';
// import Select from 'react-select';

// import BR from 'country-flag-icons/react/3x2/BR';
// // import GB from 'country-flag-icons/react/3x2/GB';
// import US from 'country-flag-icons/react/3x2/US';
// import IT from 'country-flag-icons/react/3x2/IT';
// import FR from 'country-flag-icons/react/3x2/FR';
// import RU from 'country-flag-icons/react/3x2/RU';
// import DE from 'country-flag-icons/react/3x2/DE';
// import ES from 'country-flag-icons/react/3x2/ES';

// /**
//  * Códigos de idioma do catálogo (espelham opIdiomaCatalogo do backend):
//  * 0=PT, 1=EN, 2=IT, 3=FR, 4=RU, 5=DE, 6=ES
//  */
// export const IDIOMAS_CATALOGO = [
//   { value: '0', prefixo: 'PT', nome: 'Português', Flag: BR },
//   { value: '1', prefixo: 'US', nome: 'Inglês', Flag: US },
//   { value: '2', prefixo: 'IT', nome: 'Italiano', Flag: IT },
//   { value: '3', prefixo: 'FR', nome: 'Francês', Flag: FR },
//   { value: '4', prefixo: 'RU', nome: 'Russo', Flag: RU },
//   { value: '5', prefixo: 'DE', nome: 'Alemão', Flag: DE },
//   { value: '6', prefixo: 'ES', nome: 'Espanhol', Flag: ES },
// ];

// const flagStyle = {
//   width: 22,
//   height: 15,
//   borderRadius: 2,
//   boxShadow: '0 0 0 1px rgba(0,0,0,0.12)',
//   flexShrink: 0,
// };

// const formatOptionLabel = ({ prefixo, nome, Flag }) => (
//   <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
//     <Flag title={nome} style={flagStyle} />
//     <strong style={{ fontSize: 12 }}>{prefixo}</strong>
//     <span style={{ fontSize: 12, opacity: 0.75 }}>{nome}</span>
//   </div>
// );

// const customStyles = {
//   container: (base) => ({ ...base, width: 190 }),
//   control: (base) => ({
//     ...base,
//     minHeight: 36,
//     borderColor: '#d8e0eb',
//     boxShadow: 'none',
//     ':hover': { borderColor: '#ff6d3c' },
//   }),
//   menu: (base) => ({ ...base, zIndex: 50 }),
//   valueContainer: (base) => ({ ...base, padding: '12px 8px' }),
// };

// function IdiomaCatalogoSelect({ value, onChange }) {
//   const selected =
//     IDIOMAS_CATALOGO.find((i) => i.value === String(value)) ||
//     IDIOMAS_CATALOGO[0] ||
//     null;

//   return (
//     <Select
//       classNamePrefix="idioma-catalogo"
//       aria-label="Idioma do catálogo"
//       placeholder="Idioma"
//       options={IDIOMAS_CATALOGO}
//       value={selected}
//       onChange={(opt) => onChange(opt ? opt.value : null)}
//       formatOptionLabel={formatOptionLabel}
//       styles={customStyles}
//       isSearchable={false}
//     />
//   );
// }

// IdiomaCatalogoSelect.propTypes = {
//   value: PropTypes.string,
//   onChange: PropTypes.func.isRequired,
// };

// IdiomaCatalogoSelect.defaultProps = {
//   value: null,
// };

// export default IdiomaCatalogoSelect;

import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';

import BR from 'country-flag-icons/react/3x2/BR';
// import GB from 'country-flag-icons/react/3x2/GB';
import US from 'country-flag-icons/react/3x2/US';
import IT from 'country-flag-icons/react/3x2/IT';
import FR from 'country-flag-icons/react/3x2/FR';
import RU from 'country-flag-icons/react/3x2/RU';
import DE from 'country-flag-icons/react/3x2/DE';
import ES from 'country-flag-icons/react/3x2/ES';

// Ajuste o caminho/nome do arquivo de traduções conforme onde você o salvou.
import {
  opIdiomaCatalogo,
  PORTUGUESE,
  ENGLISH,
  ITALIAN,
  FRENCH,
  RUSSIAN,
  GERMAN,
  SPANISH,
} from '../../lib/idiomaAppOptions';

/**
 * Códigos de idioma do catálogo (espelham opIdiomaCatalogo do backend):
 * 0=PT, 1=EN, 2=IT, 3=FR, 4=RU, 5=DE, 6=ES
 *
 * Cada idioma aponta para o seu dicionário de nomes. O nome exibido é o desse
 * dicionário indexado pelo idioma ATUALMENTE selecionado (ex.: ao escolher
 * Francês, todos os nomes aparecem em francês).
 */
const IDIOMAS_BASE = [
  {
    value: opIdiomaCatalogo.BR,
    prefixo: 'PT',
    Flag: BR,
    dicionario: PORTUGUESE,
  },
  { value: opIdiomaCatalogo.EN, prefixo: 'US', Flag: US, dicionario: ENGLISH },
  { value: opIdiomaCatalogo.IT, prefixo: 'IT', Flag: IT, dicionario: ITALIAN },
  { value: opIdiomaCatalogo.FR, prefixo: 'FR', Flag: FR, dicionario: FRENCH },
  { value: opIdiomaCatalogo.RU, prefixo: 'RU', Flag: RU, dicionario: RUSSIAN },
  { value: opIdiomaCatalogo.DE, prefixo: 'DE', Flag: DE, dicionario: GERMAN },
  { value: opIdiomaCatalogo.ES, prefixo: 'ES', Flag: ES, dicionario: SPANISH },
];

const flagStyle = {
  width: 22,
  height: 15,
  borderRadius: 2,
  boxShadow: '0 0 0 1px rgba(0,0,0,0.12)',
  flexShrink: 0,
};

const formatOptionLabel = ({ prefixo, nome, Flag }) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
    <Flag title={nome} style={flagStyle} />
    <strong style={{ fontSize: 12 }}>{prefixo}</strong>
    <span style={{ fontSize: 12, opacity: 0.75 }}>{nome}</span>
  </div>
);

const customStyles = {
  container: (base) => ({ ...base, width: 190 }),
  control: (base) => ({
    ...base,
    minHeight: 36,
    borderColor: '#d8e0eb',
    boxShadow: 'none',
    ':hover': { borderColor: '#ff6d3c' },
  }),
  menu: (base) => ({ ...base, zIndex: 50 }),
  valueContainer: (base) => ({ ...base, padding: '12px 8px' }),
};

function IdiomaCatalogoSelect({ value, onChange }) {
  /** idioma atualmente selecionado (fallback para PT quando vazio) */
  const idiomaAtual = useMemo(() => {
    const v = String(value);
    const existe = IDIOMAS_BASE.some((i) => i.value === v);
    return existe ? v : opIdiomaCatalogo.BR;
  }, [value]);

  /** opções com o nome traduzido para o idioma atual */
  const options = useMemo(
    () =>
      IDIOMAS_BASE.map(({ value: optValue, prefixo, Flag, dicionario }) => ({
        value: optValue,
        prefixo,
        Flag,
        nome: (dicionario && dicionario[idiomaAtual]) || '',
      })),
    [idiomaAtual]
  );

  const selected =
    options.find((i) => i.value === String(value)) || options[0] || null;

  return (
    <Select
      classNamePrefix="idioma-catalogo"
      aria-label="Idioma do catálogo"
      placeholder="Idioma"
      options={options}
      value={selected}
      onChange={(opt) => onChange(opt ? opt.value : null)}
      formatOptionLabel={formatOptionLabel}
      styles={customStyles}
      isSearchable={false}
    />
  );
}

IdiomaCatalogoSelect.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

IdiomaCatalogoSelect.defaultProps = {
  value: null,
};

export default IdiomaCatalogoSelect;
